import FilasTarefasPage from './pages/FilasTarefasPage.vue';
import FilasTarefaDadosPage from './pages/FilasTarefaDadosPage.vue';

const routes = [
  {
    path: 'filas-tarefas',
    name: 'filas-tarefas',
    component: FilasTarefasPage,
  },
  {
    path: 'filas-tarefas/:ctrl_tarefa_id',
    name: 'fila-tarefa-workflows',
    component: FilasTarefaDadosPage,
  },
];

export default routes;